import { React, useState, useRef, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation, useNavigate } from "react-router";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import { toHandlePOName } from "../../../Utils/helper/helper";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
const exportType = [
  { label: "CSV", value: "CSV" },
  // { label: "PDF", value: "PDF" },
];

const ExportProductionDetails = () => {
  const location = useLocation();
  const [records, setRecords] = useState();
  const [fileName, setFileName] = useState(location?.state?.fileName ? location.state?.fileName : "Production_Details");
  const [productionData, setProductionData] = useState(location?.state?.productionData);
  const [returnKey, setReturnKey] = useState(location?.state?.returnKey ? location.state?.returnKey : false)
  const [exportProductionDetail, setExportProductionDetail] = useState(
    exportType[0].value
  );
  const navigate = useNavigate();

  useEffect(() => {
    fetchProductionDetails();
  }, []);

  useEffect(()=> {
    if(records?.length){
      // for PDF option
      // else if (!returnKey) {
      //   navigate("../production-detail/export-production-details/pdf", {
      //     state: {
      //         body: location?.state?.body,
      //         records: records,
      //         rootPage: location?.state?.rootPage,
      //         fileNameForPDF: fileName,
      //         exportProductionDetail: exportProductionDetail
      //       },
      //   });
      // }
    }
  },[records]);

  const headers = [
    { label: "PARENT REEL/SHEET SET NO.", key: "reelNo" },
    { label: "MILL ITEM NO.", key: "mill_item_no" },
    { label: "WIDTH", key: "width" },
    { label: "LENGTH", key: "length" },
    { label: "ORDER/STOCK NO.", key: "order_stock_no" },    
    { label: "TYPE (ORDER/STOCK)", key: "order_stock_type" },
    { label: "PO NO.", key: "po_no" },
    { label: "PRODUCED SPEC", key: "produced_spec" },
    { label: "PRODUCED QTY", key: "produced_qty" },
    { label: "ACTUAL PRODUCED QTY", key: "physical_qty" },
    { label: "ACCEPTED QTY", key: "accepted_qty" },
    { label: "REJECTED QTY", key: "rejected_qty" },
    { label: "REJECTION REMARKS", key: "rejection_remarks" },
    { label: "JOB CARD NO.", key: "jc_code" },
    { label: "COMBINATION NO.", key: "combination_no" },
    { label: "PRODUCTION TYPE", key: "production_type" },
    { label: "FINISHING DATE", key: "finishing_date" },
    { label: "FINISHING SHIFT", key: "finishing_shift" },
    { label: "EXPECTED DISPATCH DATE", key: "expected_dispatch_date" },
    { label: "ORDER DELIVERY DATE", key: "delivery_date" },
    { label: "PRIORITY", key: "priority" },
    { label: "CLOSED BY", key: "closed_by" },
    { label: "CLOSED ON", key: "closed_on" }
  ];

  const fetchProductionDetails = () => {
    let exportDataJson = {};
    let  formattedList = [];
    if(!returnKey && productionData?.length){
      productionData?.map((reel) => {
        exportDataJson = {};
        let sizeKey;
        let po_value;
        let deliveryDate;
        let order_stock;
        let formattedCode = getJCCode(reel.jobcard_code);

        if(reel.type == "intermediate"){
            sizeKey = reel?.reel_size ? (reel?.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
            po_value = "";
            deliveryDate = "";
            order_stock = "";
        } else{
            sizeKey = reel.type == "sheet" ? (((reel.reel_size) + " x " + (reel.length) + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase())) : (reel.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase());
            po_value = reel.po ? reel.po : "";
            deliveryDate = reel.reel_type == "order" ? reel.delivery_date : "";
            order_stock = reel.reel_type == "order" ? (reel.order_no ? reel.order_no : "" ) : (reel.stock_no ? reel.stock_no : "");
        }
        exportDataJson["reelNo"] = reel.id;
        exportDataJson["mill_item_no"] = reel.number;
        exportDataJson["width"] = reel?.reel_size ? (reel?.reel_size + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
        exportDataJson["length"] = reel.length ? (reel.length + " " + lengthUnit[reel.units?.reel_size]?.displayName?.toUpperCase()) : "";
        exportDataJson["order_stock_no"] = order_stock;
        exportDataJson["order_stock_type"] = reel.reel_type;
        exportDataJson["po_no"] = toHandlePOName(po_value);
        exportDataJson["produced_spec"] = reel?.product?.product_spec ? reel?.product?.product_spec : "";
        exportDataJson["produced_qty"] = reel.weight + " " + capitalize(weightUnit[reel.units?.weight]?.displayName);
        exportDataJson["physical_qty"] = reel.type == "sheet" ? (reel.accepted_weight + " " + capitalize(weightUnit[reel.units?.accepted_weight]?.displayName)) : (reel.actual_weight + " " + capitalize(weightUnit[reel?.units?.actual_weight]?.displayName));
        exportDataJson["accepted_qty"] = reel.accepted_weight + " " + capitalize(weightUnit[reel.units?.accepted_weight]?.displayName);
        exportDataJson["rejected_qty"] = reel.rejected_weight + " " + capitalize(weightUnit[reel.units?.rejected_weight]?.displayName);
        exportDataJson["rejection_remarks"] = reel.comments.length !== 0 ? reel.comments[reel.comments.length - 1] : null;
        exportDataJson["jobcard_no"] = reel.jobcard;
        exportDataJson["jc_code"] = formattedCode;
        exportDataJson["combination_no"] = reel.combination_no;
        exportDataJson["production_type"] = reel.type ? capitalize(reel.type) : "";
        exportDataJson["finishing_date"] =  reel.type == "sheet" ? (reel.cutting_date ? moment(reel.cutting_date).format("DD MMM YYYY") : "") :(reel.rewinding_date ? moment(reel.rewinding_date).format("DD MMM YYYY") : "");
        exportDataJson["finishing_shift"] = reel.type == "sheet" ? reel.cutting_shift : reel.rewinding_shift;
        exportDataJson["expected_dispatch_date"] = reel.dispatch_date ? moment(reel.dispatch_date).format("DD MMM YYYY") : "";
        exportDataJson["delivery_date"] = deliveryDate ?  moment(deliveryDate).format("DD MMM YYYY") : "";
        exportDataJson["priority"] = reel.priority;
        exportDataJson["closed_by"] = reel.closed_by;
        exportDataJson["closed_on"] = reel.closing_date ? moment(reel.closing_date).format("DD MMM YYYY") : "";
        formattedList.push(exportDataJson);
      });
      setRecords(formattedList);
      setExportProductionDetail(location?.state?.exportProductionDetail);
    } else{
      setRecords(productionData);
    }
  };

  const exportStatusChange = (e) => {
    setExportProductionDetail(e.target.value);
  };

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  }

  const exportHandler = async() => {
    if(records?.length){
      if(exportProductionDetail === "CSV"){
        try{
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet('Production Records');

          worksheet.columns = headers.map((header)=>({
            header: header.label,
            key: header.key,
          }))

          const headRow = worksheet.getRow(1);

          headRow.eachCell((cell)=>{
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "f3f4f6"
              }
            }
            cell.font = {
              bold: true,
            }
          })

          records?.forEach((record)=>{
            const row = worksheet.addRow(record);
          })

          worksheet.columns.forEach((column)=>{
            let maxLength = 10;
            column.eachCell((cell)=>{
              let value = cell?.value?.toString() || "";
              maxLength = Math.max(maxLength,value?.length);
            })
            column.width = maxLength>50?50:maxLength+2;
          })

          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(new Blob([buffer]),`${fileName}.xlsx`)
        }
        catch(e)
        {
          console.log(e);
        }
      } 
      // For PDF option
      // else {
      //   navigate("../production-detail/export-production-details/pdf", {
      //     state: {
      //         body: location?.state?.body,
      //         records: records,
      //         rootPage: location?.state?.rootPage,
      //         fileNameForPDF: fileName,
      //         exportProductionDetail: exportProductionDetail
      //       },
      //   });
      //  }
      // } else{
      //   navigate(`../production-detail/preparing-export-production-details`, {
      //     state: {
      //       body: location?.state?.body,
      //       rootPage: location?.state?.rootPage,
      //       headers: headers,
      //       fileName: fileName,
      //       count: location?.state?.count,
      //       exportProductionDetail: exportProductionDetail        
      //     },
      //   });
       }
    }

  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => navigate("../production-detail")}
          title={`Export Production Records`}
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => navigate("../production-detail")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form name="basic" autoComplete="off" className="haberLogin">
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio csvStyle"
                        style={{ justifyContent: "flex-end", display: "flex", textAlign: "right" }}
                      >
                        <Radio.Group
                          options={exportType}
                          onChange={exportStatusChange}
                          value={exportProductionDetail ? exportProductionDetail : "CSV"}
                          disabled={true}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="buttonRight" style={{ marginTop: "20px" }}>
                <Form.Item>
                  {/* {!exportProductionDetail || exportProductionDetail === "PDF" ? ( */}
                  {exportProductionDetail === "PDF" ?  (<Button
                      onClick={() => exportHandler()}
                      className="themeBtn"
                    >
                      Preview & Download Records
                    </Button>
                  ) : (
                    <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download Records
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
    </RightLayoutContainer>
  );

};

export default ExportProductionDetails;
